import React from 'react';
import { Link } from 'react-router-dom';

const MasterAccountList = props => {
    if (!props.accounts) {
        return (
            <div className='broad'>Loading...</div>
        )
    }

    if (props.accounts.length === 0) {
        return (
            <div className='empty'>
                No accounts...
      </div>
        );
    }

    return (
        <div>
            <table className="dataTable">
                <thead>
                    <tr>
                      <th>Symbol</th>
                      <th>Public Key</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        props.accounts.map(item => {
                            return (
                                <tr key={item.key}>
                                    <td><Link to={`/masteraccounts/${item.key.toLowerCase()}/detail`}>{item.symbol}</Link></td>
                                    <td><Link to={`/masteraccounts/${item.key.toLowerCase()}/detail`}>{item.external}</Link></td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    );
};

export default MasterAccountList;



// WEBPACK FOOTER //
// ./src/components/widgets/MasterAccountList.js